var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53C63585-8948-4074-A5B1-0A0F1E4167D8@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_WIP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post_processing_page_delivery",
    transform: "translate(-21.000000, -145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(21.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,1.65 C5.44771525,1.65 5,2.03640063 5,2.51304996 L5,17.1848993 C5,17.6615486 5.44771525,18.0479492 6,18.0479492 C6.31338313,18.0474211 6.60835585,17.9201329 6.796875,17.7040773 L9.919922,14.698574 L13.382812,21.6012881 C13.701812,22.2382181 14.566828,22.5258572 15.298828,22.2384615 C16.020828,21.9553811 16.340672,21.2223143 16.013672,20.5983292 L12.439453,13.7664119 L18,13.7326994 C18.5522847,13.7326994 19,13.3462988 19,12.8696495 C19,12.6091454 18.8635819,12.3625953 18.628906,12.1987628 L6.7832031,1.97701498 C6.59363832,1.77056898 6.30521121,1.65 6,1.65 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.cb12ab440035c878e504166a1095f3a0.svg";
export { ForwardRef as ReactComponent };